/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PHOTO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	photo: {
		backgroundColor: 'transparent',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain',
		display: 'block',

		'&.name-placeholder': {
			backgroundImage: `url(${url.image.app}/photo-placeholder.png)`,
			height: pxToEm(100),
			width: pxToEm(125)
		},
	}
});